export default{
    newCount(state){
        return state.count*10;
    }
}